import { FC, useCallback } from 'react';

import useTrls from 'hooks/translation/useTrls';

import LabelSort from 'components/Admin/Reports/ActsReport/ActsTable/Header/LabelSort';
import { sortActs } from 'components/Admin/Reports/ActsReport/ActsTable/Header/sortActs';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { Act } from 'store/models/acts';
import { useDispatch } from 'store/utils';

const COLUMN_EMPLOYER = 'employerId';
interface HeaderProps {
    disableSorts?: boolean;
}

const Header: FC<HeaderProps> = ({ disableSorts }) => {
    const dispatch = useDispatch();

    const trl = useTrls();

    const onClick = useCallback(
        (sortType: string) => {
            if (!disableSorts) {
                dispatch(sortActs(sortType as keyof Act));
            }
        },
        [disableSorts, dispatch]
    );

    return (
        <TableRow>
            <TableHeadCell>{trl('admin.actsReport.actsTable.header.actInfo')}</TableHeadCell>
            <TableHeadCell onClick={() => onClick(COLUMN_EMPLOYER)}>
                <LabelSort column={COLUMN_EMPLOYER} disableSorts={disableSorts} />
            </TableHeadCell>
            <TableHeadCell>{trl('admin.actsReport.actsTable.header.amount')}</TableHeadCell>
            <TableHeadCell>{trl('admin.actsReport.actsTable.header.documentNumber')}</TableHeadCell>
            <TableHeadCell>{trl('admin.actsReport.actsTable.header.actType')}</TableHeadCell>
            <TableHeadCell>{trl('admin.actsReport.actsTable.header.statuses')}</TableHeadCell>
            <TableHeadCell />
        </TableRow>
    );
};

export default Header;
